"use client";

import type { ResolvedLocale } from "@homeinstead/locale";
import type { ReactNode } from "react";

import { createContext, useContext } from "react";

type LocaleProviderValue = ResolvedLocale;

const LocaleContext = createContext<LocaleProviderValue | null>(null);

type LocaleProviderProps = {
  children: ReactNode;
  value: LocaleProviderValue;
};

function LocaleProvider({ children, value }: LocaleProviderProps) {
  return (
    <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
  );
}

function useLocale(): LocaleProviderValue {
  const context = useContext(LocaleContext);

  if (!context) {
    throw new Error("useLocale must be used within a LocaleProvider");
  }

  return context;
}

export { LocaleProvider, useLocale };
